// extracted by mini-css-extract-plugin
module.exports = {"emoji_wrap":"styles_emoji_wrap__1r8pQ","emoji":"styles_emoji__3SQTf"};